import { PropsWithChildren, useState } from "react";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";

export function TableHeaderSort(props: PropsWithChildren<TableHeaderSortType>) {
  const [active, setActive] = useState<number | null>(null)

  const toggleActive = (index: number, item: string) => {
    setActive(index === active ? null : index)
    const newSort = index === active ? 'desc' : 'asc'
    props.onSort && props.onSort(item, newSort);
  }

  return (
    <>
      {props?.title.map((item: TableSorting, index) => {
        return (
          (item.isActive === undefined || item.isActive === true) &&
          <th
            key={index}
            colSpan={item?.colspan}
            onClick={() => item?.sort ? toggleActive(index, item?.title) : null}
            className={`${item.className} ${item?.sort ? "cursor-pointer" : ""}`}
          >
            <div className={`flex gap-2 items-center ${item.align === 'right' ? 'justify-end' : (item.align === 'left' ? 'justify-start' : 'justify-center')}`}>
              {item?.title}
              {item?.sort ? index === active ? <IoIosArrowUp className="w-5 h-5" /> : <IoIosArrowDown className="w-5 h-5" /> : null}
            </div>
          </th>
        )
      })}
    </>
  )
}

export type TableSorting = {
  title: string;
  sort?: boolean
  align?: string;
  colspan?: number;
  className?: string;
  isActive?: boolean;
  colSpan?: number,
  rowSpan?: number
  value?: string
}
type TableHeaderSortType = {
  title: TableSorting[],
  onSort?: (item: string, sortType: "desc" | "asc") => void,
  className?: string,
  
}